<template>
  <div id="app">
    <keep-alive
      :include="['recommend','Main','Guess','QuestionDetail','ExamDetail','VideoDetail','ParaDetail','MyFavourite','SearchDetail','Activity','VideoShare','ExperimentDetail','CatalogueShare','Homepage']"
    >
      <router-view />
    </keep-alive>
  </div>
</template>

<script>
import { initMathjax } from "@/js/talqs.js";
import { initFingerPrint } from "@/js/utils/initFingerPrint.js";
import TAL_UC from "@udc/tal-passport-jssdk";
import {clientId} from '@/js/utils/constant.js'
const isProd=process.env.env_config=='prod'||process.env.env_config=='production'
export default {
  name: "App",
  async created() {
    initMathjax();
    await initFingerPrint();
    TAL_UC.rankConfig({
      "client-id":clientId , // client-id由平台发放权限码，接入之前向平台申请
      env: isProd ? "production" : "sandbox", // 环境标识： 'sandbox': 沙箱环境； 'production': 线上生产环境；默认为生产(备注，引入npm包才需要该字段)
      domain: "", // udc中台分配的业务二级域名，联系焦杰老师，如passport.xueersi.com（v1.19.01版sdk开始支持）
    });
    TAL_UC.getDeviceInfo({
        success: (res) => {
          const deviceId = res.data["d-id"] || res.data["device-id"]||"";
          localStorage.setItem("X-Device-Id", deviceId);
          this.$store.commit('User/updateDeviceId',deviceId)
        },
        fail: (error) => {
          console.log("udc初始化设备信息失败", error);
        },
      });
  },
  methods: {
    
  }
};
</script>

<style lang="scss">
@import url(./assets/style/rem.css);
@import url(./assets/style/reset.css);
@import url(./assets/style/border.css);
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  font-size: 14px;
  // background: rgba(251, 247, 245, 1);
  // background: url(./assets/img/background.png);
}
p {
  margin: 0;
}
// .van-dialog {
//   width: 2.21rem;
//   height: 1.31rem;
//   background: rgba(254, 255, 255, 1);
//   box-shadow: 0px 2px 15px 0px rgba(65, 80, 83, 0.18);
//   border-radius: 0.23rem;
// }
// .van-dialog__content--isolated {
//   min-height: 0.74rem;
// }
// .van-dialog__cancel {
//   border-radius: 9rem;
//   color: rgba(132, 133, 134, 1) !important;
//   margin-right: 0.08rem;
// }
.van-dialog {
  border-radius: 4px;
}
.van-overlay {
  background-color: rgba(#000, 0.3);
}
</style>



// WEBPACK FOOTER //
// src/App.vue